import { FC } from 'react';
import { WbDrawer, WbTag } from '@agilelab/plugin-wb-platform';
import { makeStyles, Typography } from '@material-ui/core';

import { useReleaseDetailPageContext } from '../context/useReleaseDetailPageContext';
import { AdvancedProvisioning } from './AdvancedProvisioning';
import { BasicProvisioning } from './BasicProvisioning';
import { useDeploymentPreviewContext } from './context/useDeploymentPreviewContext';
import { snakeCaseToTitleCase } from '@agilelab/plugin-wb-platform-common';
import { DeploymentSummary } from './DeploymentSummary';

const useStyles = makeStyles(theme => ({
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  titleContainer: {
    background: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
  },
}));

export const DeploymentPreviewDrawer: FC = () => {
  const { isAdvanced, setTemporarySelectedItems } =
    useDeploymentPreviewContext();
  const {
    isDeploymentPreviewOpen,
    setIsDeploymentPreviewOpen,
    release,
    queryParamEnvironment,
    environment,
    queryParamVersion,
    projectName,
  } = useReleaseDetailPageContext();

  const classes = useStyles();
  return (
    <WbDrawer
      size={95}
      open={isDeploymentPreviewOpen}
      title={
        <>
          <div className={classes.title}>
            <Typography variant="h6">
              {queryParamVersion || release.metadata.version} of {projectName}
            </Typography>
            <WbTag
              tag={{
                tagFQN: snakeCaseToTitleCase(
                  queryParamEnvironment || environment.name,
                ),
              }}
            />
          </div>
        </>
      }
      setOpen={() => {
        setIsDeploymentPreviewOpen(false);
        setTemporarySelectedItems([]);
      }}
    >
      <DeploymentSummary />
      {isAdvanced ? <AdvancedProvisioning /> : <BasicProvisioning />}
    </WbDrawer>
  );
};
